import { motion } from 'framer-motion';
import { IMAGES } from '@/lib/content';

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#f9f2e0] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1200px] mx-auto px-6 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Photo */}
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-4 relative w-full max-w-[340px] mx-auto lg:mx-0"
        >
          <div className="absolute -top-5 -left-5 w-2/3 h-2/3 bg-[#d4a94a] hidden md:block" />
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={IMAGES.coachAbout}
              alt="Anabela Moreira, coach de vie professionnelle"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </motion.div>

        {/* Text */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-8"
        >
          <p className="text-xs uppercase tracking-[0.3em] text-[#a1802f] mb-6">
            Qui suis-je · Anabela Moreira
          </p>
          <h2 className="font-serif font-light text-[#1c1811] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Derrière les mots…
            <br />
            <span className="italic text-[#a1802f]">une femme en chemin</span>.
          </h2>
          <div className="mt-8 space-y-6 text-[#1c1811]/70 text-base md:text-lg leading-relaxed max-w-2xl">
            <p>
              J'ai grandi dans un foyer modeste, portée par l'amour inconditionnel
              de mes parents. Ils m'ont transmis l'essentiel : le courage de tenir
              bon, la dignité face à l'adversité, et la force de croire en mes
              rêves. Mon ambition est née de leur réalité.
            </p>
            <p>
              De comptable à responsable RH, de salariée à entrepreneure, j'ai
              gravi les échelons sans jamais trahir mes valeurs. Mais il y a eu
              des secousses : un deuil, un harcèlement en entreprise, un divorce,
              un burn-out. J'ai eu l'impression que tout s'effondrait.
            </p>
            <p>
              Puis j'ai découvert un autre chemin : celui de la connaissance de
              soi, de l'émotion, du cœur. En 2019, j'ai mis un mot sur ce que je
              ressentais depuis toujours :{' '}
              <span className="italic text-[#a1802f]">hypersensible</span>. Ce
              qui avait été une fragilité est devenu ma force.
            </p>
            <p className="text-[#1c1811]">
              Aujourd'hui, j'avance en femme libre. La réussite n'est pas un
              objectif extérieur, mais un mouvement intérieur. C'est ce que
              j'accompagne : votre transformation durable à travers votre propre
              système vivant.
            </p>
          </div>

          <div className="mt-12">
            <p className="font-serif italic text-2xl md:text-3xl text-[#1c1811] leading-snug mb-6 max-w-xl">
              90 jours pour transformer. 5 étapes clés et une méthode qui vous
              ressemble.
            </p>
            <a
              href="https://calendly.com/contact-conseils-et-reussites-academie/entretien-prive-clarte" target="_blank" rel="noopener noreferrer"
              data-testid="about-cta"
              className="group inline-flex items-center gap-3 bg-[#d4a94a] text-[#1c1811] px-9 py-4 text-sm uppercase tracking-[0.15em] font-medium hover:bg-[#b3892f] transition-colors duration-300"
            >
              Réserver un appel
              <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
                &rarr;
              </span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
